import { cn } from 'lib/helpers/utility';

const DocCard = ({ children, className }) => (
  <div className={cn('rounded-lg border border-solid border-neutral-400 px-5 py-2.5', className)}>
    {children}
  </div>
);

export default DocCard;
